// @flow
import React from "react";
import classnames from "classnames";

export default (props: Object) => (
  <span style={props.style} className={classnames("badge", props.className)}>
    {props.children}
  </span>
);
